import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

type NotesValue = string | number | null | undefined

interface NotesPreviewProps {
  note: NotesValue
  emptyLabel?: string
  className?: string
}

const NotesPreview: React.FC<NotesPreviewProps> = ({
  note,
  emptyLabel = '-',
  className,
}) => {
  if (note === null || note === undefined) {
    return <span className={css(styles.empty)}>{emptyLabel}</span>
  }

  const value = typeof note === 'string' ? note : String(note)
  if (value.trim().length === 0) {
    return <span className={css(styles.empty)}>{emptyLabel}</span>
  }

  const combinedClassName = className
    ? `${css(styles.box)} ${className}`
    : css(styles.box)

  return <div className={combinedClassName}>{value}</div>
}

const styles = StyleSheet.create({
  box: {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    minWidth: 320,
    maxHeight: 140,
    overflowY: 'auto',
    padding: '6px 10px',
    borderRadius: 6,
    border: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
    color: '#4B5563',
    fontSize: 12,
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    '@media (max-width: 1024px)': {
      minWidth: 'auto',
      maxHeight: 160,
      fontSize: 11,
    },
  },
  empty: {
    color: '#6B7280',
  },
})

export default NotesPreview
